export default Object.freeze({
  Unknown: 0,
  ProcessInstancePendingApproval: 1,
  ProcessInstancePendingCompleteInformation: 2,
  ProcessInstancePendingTaskCompletion: 3,
  ProcessInstancePendingSignature: 4,
  ProcessInstanceApprovalSecurityCode: 5,
  ProcessInstanceActionSendEmail: 6,
  ProcessInstanceNewCommentNotification: 7,
  ProcessInstanceScheduledExecutionNotification: 8,
  ProcessInstanceApprovedNotification: 9,
  ProcessInstanceRejectedNotification: 10,
  ProcessInstanceCanceledNotification: 11,
  ProcessInstanceVoidedNotification: 12,
  ProcessInstanceWithErrorsNotification: 13,
  UserAccountConfirmation: 14,
  UserAccountWelcomeMessage: 15,
  UserAccountResetPassword: 16,
  UserAccountTwoFactorValidationCode: 17,
  UserAccountSecurityAlertNewLogin: 18,
  InternalTaskErrorNotification: 19,
  InternalTaskEntityFileReadyToDownloadNotification: 20,
  InternalTaskEntityFileImportFinishNotification: 21,
  FormFieldApiWithErrorsNotification: 22,
  MaintenanceCompanyDeactivationNotification: 23,
  ProcessInstanceReassigned: 24,
  SystemReportInternalTaskCompletedNotification: 25,
  TaskAssigned: 26,
  AgentEmailMessage: 27,
  InternalTaskListFileReadyToDownloadNotification: 28,
  AIBillingBudgetAlertNotification: 29,
  AIBillingMonthlyCreditGrantedNotification: 30,
});
